/**
 * SuccessMessage Component
 * Success notification after form submission
 */

import React from "react";

const SuccessMessage = () => {
  return (
    <div className="App">
      <div className="success-message">
        <h2>✓ Terima Kasih!</h2>
        <p>Penilaian Anda telah berhasil dikirim.</p>
        <p>
          Feedback Anda sangat berharga bagi kami untuk meningkatkan kualitas
          layanan.
        </p>
      </div>
    </div>
  );
};

export default SuccessMessage;
